import { createStorageSlot } from '@gonfalon/browser-storage/createStorageSlot';

import { createStorageKey } from './internal/createStorageKey';

export function flashMessage(key: string, message: string) {
  const slot = createStorageSlot(createStorageKey(key), { storageType: 'sessionStorage' });
  slot.set(message);
}
